import { AnyAction } from '@reduxjs/toolkit';

const actionTypeErrorGuard = (action: AnyAction) =>
  action.type.endsWith('/rejected');

export default actionTypeErrorGuard;
